import React from 'react'
import isEqual from 'lodash/isEqual';
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { OBJECT_FORM } from './Form'
import { touch } from 'redux-form'
import VisualComponent from '../../../../components/DtObjectsComponent'
import {getFieldListFields, getGroupModel, getLanguage, getModule} from '../../selectors'
import getFormValidations from './formValidations'
import {exportTableObject} from "../../actions/api";

class FormDtObjectsField extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            validations: getFormValidations(props.field, props.t, props.listFields)
        }
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.listFields, this.props.listFields)) {
            const validations = getFormValidations(this.props.field, this.props.t, this.props.listFields);
            this.setState({ validations });
        }
    }

    render() {
        const {field, listFields, module, t, touch, exportTableObject, language, groupModel, objectMode} = this.props
        const disabled = field.disabled
        const editable = !field.editable ? objectMode === 'newObject' : field.editable
        return (
            <Field
                name={field.path}
                path={field.tKey || field.path}
                required={field.required}
                displayTooltip={field.displayTooltip}
                exportTableObject={exportTableObject}
                component={VisualComponent}
                validate={this.state.validations}
                disabled={disabled || !editable}
                validateOnChange={true}
                listFields={listFields}
                field={field}
                module={module}
                defaultSortBy={field.defaultSortBy}
                defaultSortDirection={field.defaultSortDirection}
                t={t}
                language={language}
                touch={touch}
                groupModel={groupModel}
            />
        )
    }
}

const mapStateToProps = (state, { field }) => ({
    module: getModule(state),
    groupModel: getGroupModel(state),
    listFields: getFieldListFields(state, field.id),
    language: getLanguage(state)
})

const mapDispatchToProps = (dispatch, {user, groupModel, language}) => ({
    exportTableObject: (filename, columns, object) =>
        dispatch(exportTableObject(filename, columns, object, user, false, language, groupModel)),
    touch: field =>
        dispatch(touch(OBJECT_FORM, field))
})


export default connect(mapStateToProps, mapDispatchToProps)(FormDtObjectsField)
